module.exports = __webpack_public_path__ + "img/24.91e92fbf.png";